<template>
  <v-card>
    <v-form ref="form" v-model="valid">
      <alert-error :error="error"></alert-error>
      <v-card-title>
        {{ $t('REPORTS.ALL_INHABITANTS_OF_B_CUSTOMER_HISTORY') }}
      </v-card-title>

      <v-card-text>
        <v-select
          v-model="businessCustomerId"
          :loading="!businessCustomers.length"
          :items="businessCustomers"
          :rules="rules.requiredSelectNotArray"
          item-value="id"
          item-text="name"
          :label="`${$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER')} *`"
          clearable
        ></v-select>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!valid" @click="getFile">
          {{ $t('BUTTON.EXPORT') }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import downloadFile from '@/modules/_global/mixins/download-file';
import moment from 'moment';
import { mapActions } from 'vuex';
import { BUSINESS_CUSTOMER } from '@/modules/companies/common/companyTypes';
import { ReportsService } from '@/services/reports.service';
import { requiredSelectNotArray } from '@/modules/_global/variables/rules';

export default {
  name: 'BusinessCustomerHabitationHistory',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  mixins: [downloadFile],

  data: () => ({
    businessCustomers: [],
    businessCustomerId: null,
    dataExport: null,
    datetimeNow: '',
    error: null,
    valid: false,
    rules: {
      requiredSelectNotArray
    }
  }),

  computed: {
    fileName() {
      let rootName = this.$t('REPORTS.ALL_INHABITANTS_OF_B_CUSTOMER_HISTORY');

      return `${rootName} ${this.datetimeNow}`;
    }
  },

  created() {
    this.datetimeNow = moment().format('YYYY-MM-DD');

    this.retrieveCompaniesByType(BUSINESS_CUSTOMER)
      .then(response => (this.businessCustomers = response.data))
      .catch(error => {
        this.error = error.response;
      });
  },

  methods: {
    ...mapActions('company', ['retrieveCompaniesByType']),

    getFile() {
      return ReportsService.retrieveBusinessCustomerHabitationHistory(
        this.businessCustomerId
      )
        .then(response => {
          this.downloadFile(response, this.fileName);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
